import { notifyError, notifySuccess } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";

export const getAllDocumentsData = () => async (dispatch) => {
  dispatch({ type: "SHOW_DOCUMENT_LOADING" });
  try {
    const { data } = await auction.get("/profile/read/all-documnets");
    dispatch({ type: "GET_ALL_DOCUMENT", payload: data });
  } catch (error) {
    notifyError(error.response ? error.response?.data : error.message, error.response?.status);
    dispatch({ type: "SHOW_DOCUMENT_LOADDED" });
  }
};

export const uploadDocumentsData =
  (documents, setUploadValue) => async (dispatch) => {
    const formData = new FormData();

    const data = [
      { key: "document", value: documents?.file },
      { key: "fileType", value: documents?.fileType },
      { key: "status", value: documents?.status || "pending" },
    ];

    data.forEach((item) => formData.append(item.key, item.value));
    dispatch({ type: "UPLOAD_DOCUMENT_LOADING" });
    try {
      await auction.put("/profile/update/document", formData).then((res) => {
        dispatch({ type: "UPLOAD_DOCUMENT_SUCCESS" });
        notifySuccess("Document updated successfully");
        dispatch(getAllDocumentsData());
        setUploadValue({
          file: null,
          fileType: "",
        });
      });
    } catch (error) {
      dispatch({ type: "UPLOAD_DOCUMENT_FAILED" });
      notifyError(error.response ? error.response?.data : error.message, error.response?.status);
    }
  };

export const downloadFile = (downloadFile, fileName) => async (dispatch) => {
  const toastID = toast.loading("please wait..");

  dispatch({ type: "DOWNLOADING_FILE" });
  try {
    const response = await auction.get(
      `/documents/read/single-file/${downloadFile}`,
      {
        responseType: "blob",
      }
    );

    const contentDisposition = response.headers["content-disposition"];
    let filename = fileName;
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="(.+)"/);
      if (filenameMatch && filenameMatch.length === 2) {
        filename = filenameMatch[1];
      }
    }

    const blob = new Blob([response.data], { type: response.data.type });

    saveAs(blob, filename);
    toast.update(toastID, {
      render: "File downloaded successfully",
      isLoading: false,
      autoClose: 5000,
      type: "success",
    });
  } catch (error) {

    toast.update(toastID, {
      render: error.response ? error.response?.data : error.message,
      isLoading: false,
      autoClose: 5000,
      type: "error",
    });

    dispatch({ type: "FAILED_DOWNLOAD_FILE" });
  }
};

export const getViewDocument = (fileId) => async (dispatch) => {
  if (!fileId) return
  dispatch({ type: "VIEW_DOCUMENT_LOADING" });
  try {
    const response = await auction.get(`/documents/read/single-file/${fileId}`, {
      responseType: "blob",
    });
    const blob = new Blob([response.data], { type: response.data.type });
    const pdfUrl = URL.createObjectURL(blob);
    dispatch({ type: "VIEW_DOCUMENT_SUCCESS", payload: pdfUrl, fileType: response.data.type });
  } catch (error) {
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status
    );
    dispatch({ type: "VIEW_DOCUMENT_FAILED" });
  }
};

export const uploadInitailReqiuredDoucment =
  (formData, setDocumentFileList, navigate) =>
    async (dispatch) => {
      dispatch({ type: "SHOW_LOADING" });
      try {
        await auction.put("/profile/update/multi-documents", formData)
        dispatch({ type: "HIDE_LOADING" });
        notifySuccess("Document uploaded successfully");
        setDocumentFileList([]);
        navigate("/select-scrap");

      } catch (error) {
        dispatch({ type: "HIDE_LOADING" });
        notifyError(error.response ? error.response?.data : error.message, error.response)
      }

    };
